<template>
  <div>

    <EmptyCardModal
      v-if="adjustStoreModal"
      ref="emptyModal"
      :onModalClose="(reset) => adjustStoreModal = null"
      :onModalAccept="() => adjustStoreAction(adjustStoreModal.drugId, true)"
      :modalData="adjustStoreModal"
    >
      <slot>
        <div class="row">
          <div class="col-md-6">
            <template v-if="adjustStoreModal.invoices.income.qty">
              <p>Поступление <strong>{{ sortedStores[3]?.short_title }}</strong> количество
                <strong>{{ adjustStoreModal.invoices.income.qty }}</strong></p>
              <hr>
            </template>
            <template v-if="adjustStoreModal.invoices.writeOff.length">
              <p v-for="writeOff in adjustStoreModal.invoices.writeOff">Списание
                <strong>{{ sortedStores[writeOff.store_out]?.short_title }}</strong> количество
                <strong>{{ writeOff.qty }}</strong></p>
              <hr>
            </template>
            <p v-for="transit in adjustStoreModal.invoices.transit">Транзит
              <strong>{{ sortedStores[transit.store_out]?.short_title }}</strong> =>
              <strong>{{ sortedStores[transit.store_in]?.short_title }}</strong> количество
              <strong>{{ transit.qty }}</strong></p>
          </div>
          <div class="col-md-6 border-left">
            <p v-for="(qty, storeId) in adjustStoreData[adjustStoreModal.drugId].newStoreQty"
               v-if="+storeData.actualStoreData[adjustStoreModal.drugId][storeId] !== +qty">
              {{ sortedStores[storeId]?.short_title }}
              <strong>{{ storeData.actualStoreData[adjustStoreModal.drugId][storeId] }}</strong>
              => <strong>{{ qty }}</strong></p>
            <p v-for="s in adjustStoreData[adjustStoreModal.drugId].newStore"
               v-if="+s.storeId && +s.newQty !== +storeData.actualStoreData[adjustStoreModal.drugId][s.storeId]">
              {{ sortedStores[s.storeId]?.short_title }}
              <strong>{{
                  storeData.actualStoreData[adjustStoreModal.drugId][s.storeId]
                }}</strong>
              => <strong>{{ s.newQty }}</strong></p>
          </div>
        </div>
      </slot>
    </EmptyCardModal>

    <table class="table table-sm table-hover">
      <thead>
      <tr>
        <template v-if="showDrugTitle">
          <th>Морион</th>
          <th>Наименование</th>
        </template>
        <th>Склад</th>
        <th>Наличие</th>
        <th>Фактич</th>
        <th></th>
        <th>Р. бронь</th>
        <th>Не р. бронь</th>
        <th>В дороге</th>
      </tr>
      </thead>
      <tbody>
      <template v-for="drug in selectedDrugs" v-if="storeData && storeData.inStores[drug.id]">
        <template v-if="showDrugTitle">
          <tr class="main_tr">
            <td :rowspan="getRecordsCount(drug.id)">{{ drug.id }}</td>
            <td :rowspan="getRecordsCount(drug.id)">
              <template v-if="allowToGetMoves">
                <a :href="getExternalLink(drug)" target="_blank"><i class="icon-fa icon-fa-external-link"></i></a>
                <span @click="mixinGoToRouter('NomenclatureStatistics', {drugId: drug.id})"
                      class="pointer">{{ drug.title }}</span>
              </template>
              <template v-else>
                {{ drug.title }}
              </template>
              <template v-if="drug.pack_set && drug.pack_set != 1">
                <p class="mb-0 badge badge-info">комплект x {{ drug.pack_set }}</p>
                <p class="text-muted">Учет ведется в заводских упаковках!</p>
              </template>

              <template v-if="$can('stores/status/autoAdjust')">
                <div class="mt-2">
                  <p v-for="inv in storeData.extraInvoices">
                    {{ inv.extra_type ? 'Коррекция' : 'Списание' }} <strong>{{ inv.total }}</strong>
                    <template v-if="inv.extra_type">
                      <button @click="showExtraInvoices(inv, drug.id)" type="button"
                              class="btn btn-xs btn-outline-info">
                        <i class="icon-fa icon-fa-eye"/></button>
                    </template>
                    <template v-else>
                      <LoadingButton
                        title='<i class="icon-fa icon-fa-eye"/>'
                        :loading="writeOffLoading[drug.id]"
                        type="button"
                        :color="$constants.PRIMARY_COLOR"
                        :onClick="() => showExtraInvoices(inv, drug.id)"
                        className="btn btn-xs btn-outline-info"
                      />
                    </template>
                  </p>
                </div>
              </template>
            </td>
          </tr>
        </template>
        <tr v-for="store in getStores()"
            v-if="(storeData.inStores[drug.id] && storeData.inStores[drug.id][store.id]) || (storeData.requests[drug.id] && storeData.requests[drug.id][store.id]) || (storeData.transitDetails[drug.id] && storeData.transitDetails[drug.id][store.id])">
          <td width="250px" v-bind:class="{grey_field: store.id === 3}">
            <template v-if="allowToGetMoves">
              <a :href="getExternalLink(drug, store.id)" target="_blank"><i
                class="icon-fa icon-fa-external-link"></i></a>
              <template v-if="!hideStoreLink">
              <span class="pointer"
                    @click="mixinGoToRouter('NomenclatureStatistics', {drugId: drug.id, storeId: store.id })">{{
                  store.title
                }} ({{ store.id }})</span>
              </template>
              <template v-else>
                <span>{{ store.title }} ({{ store.id }})</span>
              </template>
            </template>
            <template v-else>
              {{ store.title }}
            </template>
          </td>
          <td class="grey_field w_store_d">
            <strong>{{ (Math.round(storeData.inStores[drug.id][store.id] * 10) / 10) || 0 }}</strong></td>
          <td class="w_store_d">
            {{ storeData.actualStoreData[drug.id] && storeData.actualStoreData[drug.id][store.id] || 0 }}
          </td>
          <td>
            <template v-if="adjustStore && adjustStore[drug.id]">
              <input type="number" v-model="adjustStoreData[drug.id].newStoreQty[store.id]" placeholder="Новое кол."
                     class="form-control">
            </template>
          </td>
          <td class="w_store_d">
            <template
              v-if="storeData.requests && storeData.requests[drug.id] && storeData.requests[drug.id][store.id] && storeData.requests[drug.id][store.id][reserveTypes.appointedReserve] && storeData.requests[drug.id][store.id][reserveTypes.appointedReserve].qty">
              <template v-if="showStoreDataTooltip[drug.id]">
                <v-popover
                  class=""
                  popoverClass="1111 p-3"
                  popoverInnerClass="upload_file_component_popover"
                  :update="(open) => {console.log('111', open);}"
                  :close-directive="() => {console.log('1112');}"
                  trigger="hover"
                  :auto-hide="true">
                  <div class="badge badge-dark pointer fs-12">
                    {{ storeData.requests[drug.id][store.id][reserveTypes.appointedReserve].qty }}
                  </div>
                  <template slot="popover">
                    <div class="pre_image">
                      Заявки:
                      <p class="mb-1"
                         v-for="o in storeData.requests[drug.id][store.id][reserveTypes.appointedReserve].orders">
                        {{ o }}</p>
                      <p>
                        <a href="#"
                           @click.prevent="openInNewPage('searchOrder', {ordersId: storeData.requests[drug.id][store.id][reserveTypes.appointedReserve].orders})">
                          Показать заявки
                        </a>
                      </p>

                    </div>
                  </template>
                </v-popover>
              </template>
              <template v-else>
                <div @mouseover="showStoreDataTooltip[drug.id] = true" class="badge badge-dark pointer fs-12">
                  {{ storeData.requests[drug.id][store.id][reserveTypes.appointedReserve].qty }}
                </div>
              </template>
            </template>
            <template v-else>0</template>
          </td>
          <td class="w_store_d">
            <template
              v-if="storeData.requests && storeData.requests[drug.id] && storeData.requests[drug.id][store.id] && storeData.requests[drug.id][store.id][reserveTypes.noAppointedReserve] && storeData.requests[drug.id][store.id][reserveTypes.noAppointedReserve].qty">
              <template v-if="showStoreDataTooltip[drug.id]">
                <v-popover
                  class=""
                  popoverClass="1111 p-3"
                  popoverInnerClass="upload_file_component_popover"
                  trigger="hover"
                  :auto-hide="true">
                  <div class="badge badge-dark pointer fs-12">
                    {{ storeData.requests[drug.id][store.id][reserveTypes.noAppointedReserve].qty }}
                  </div>
                  <template slot="popover">
                    <div class="pre_image">
                      Заявки:
                      <p class="mb-1"
                         v-for="o in storeData.requests[drug.id][store.id][reserveTypes.noAppointedReserve].orders">
                        {{ o }}</p>
                      <p>
                        <a href="#"
                           @click.prevent="openInNewPage('searchOrder', {ordersId: storeData.requests[drug.id][store.id][reserveTypes.noAppointedReserve].orders})">
                          Показать заявки
                        </a>
                      </p>
                    </div>
                  </template>
                </v-popover>
              </template>
              <template v-else>
                <div @mouseover="showStoreDataTooltip[drug.id] = true" class="badge badge-dark pointer fs-12">
                  {{ storeData.requests[drug.id][store.id][reserveTypes.noAppointedReserve].qty }}
                </div>
              </template>
            </template>
            <template v-else>0</template>
          </td>
          <td class="w_store_d">
            <template v-if="storeData.transitDetails[drug.id] && storeData.transitDetails[drug.id][store.id]">
              <template v-if="showStoreDataTooltip[drug.id]">
                <v-popover
                  class=""
                  popoverClass="1111 p-3"
                  popoverInnerClass="upload_file_component_popover"
                  trigger="hover"
                  :auto-hide="true">
                  <div class="badge badge-dark pointer fs-12">
                    {{ getTransitQty(storeData.transitDetails[drug.id][store.id]) }}
                  </div>
                  <template slot="popover">
                    <div class="pre_image">
                      Накладные:
                      <template v-if="storeData.transitDetails[drug.id][store.id].details_in">
                        <p>Поступление:</p>
                        <p class="mb-1" v-for="i in storeData.transitDetails[drug.id][store.id].details_in">
                          {{ i.invoice_id }} ({{ i.qty }})</p>
                      </template>
                      <template v-if="storeData.transitDetails[drug.id][store.id].details_out">
                        <p>Отправка:</p>
                        <p class="mb-1" v-for="i in storeData.transitDetails[drug.id][store.id].details_out">
                          {{ i.invoice_id }} ({{ i.qty }})</p>
                      </template>
                    </div>
                  </template>
                </v-popover>
              </template>
              <template v-else>
                <div @mouseover="showStoreDataTooltip[drug.id] = true" class="badge badge-dark pointer fs-12">
                  {{ getTransitQty(storeData.transitDetails[drug.id][store.id]) }}
                </div>
              </template>
            </template>
            <template v-else>0</template>
            <div class="border p-1"
                 v-if="storeData.transitDetails[drug.id]?.[store.id]?.in && storeData.transitDetails[drug.id]?.[store.id]?.out">
              -{{ storeData.transitDetails[drug.id][store.id].out }}c/+{{
                storeData.transitDetails[drug.id][store.id].in
              }}на
            </div>
          </td>
        </tr>
        <template v-if="$can('stores/status/autoAdjust')">
          <template v-if="adjustStore[drug.id]">
            <tr v-for="(adjust, i) in adjustStoreData[drug.id]?.newStore">
              <td colspan="2"></td>
              <td>
                <select v-model="adjust.storeId" class="form-control">
                  <option disabled value="0">Выберите склад</option>
                  <option v-for="s in $AllStores" v-if="adjust.allowedStores[s.id]" :value="s.id">{{ s.title }}
                    ({{ s.id }})
                  </option>
                </select>
              </td>
              <td colspan="2"></td>
              <td>
                <input type="number" v-model="adjust.newQty" placeholder="Новое кол." class="form-control">
              </td>
              <td colspan="3" align="right" v-if="i === 0">
                <button type="button" @click="adjustStoreAction(drug.id)" class="btn btn-outline-success">
                  Обновить склады
                </button>
              </td>
            </tr>
          </template>
          <template v-else>
            <tr v-if="!disableCorrection">
              <td colspan="12">
                <label>
                  <input type="checkbox" @change="editAdjustStore(drug.id)" v-model="adjustStore[drug.id]">
                  корректировать склады
                </label>
              </td>
            </tr>
          </template>
        </template>
      </template>
      </tbody>
    </table>
  </div>
</template>

<script>

import api from "@/api";
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import EmptyCardModal from "@/components/modals/EmptyCardModal.vue";

export default {
  props: ['storeData', 'selectedDrugs', 'allowToGetMoves', 'showDrugTitle', 'hideStoreLink', 'disableCorrection'],
  components: {
    LoadingButton,
    EmptyCardModal,
  },
  data() {
    return {
      writeOffLoading: {},
      adjustStoreModal: null,
      adjustStore: {},
      adjustStoreData: {},
      showStoreDataTooltip: {},
      sortedStores: {},
      reserveTypes: {
        'noAppointedReserve': 1,
        'appointedReserve': 2
      }
    }
  },
  computed: {
    $AllStores() {
      const stores = this.$store.getters['platform/stores']
      return _.orderBy(stores, 'id')
    },
  },
  created() {
    this.showStoreDataTooltip = Object.keys(this.storeData.actualStoreData).reduce((acc, d) => {
      acc[d] = false
      return acc
    }, {});
    this.sortedStores = this.$AllStores.reduce((acc, s) => {
      acc[s.id] = {...s};
      return acc;
    }, {})
  },
  methods: {
    getStores() {
      return this.$currentRole === 'admin' ? this.$AllStores : this.$AllStores.filter((s) => s.id !== 35);
    },
    async showExtraInvoices(invoices, drugId) {
      if (invoices.extra_type) {
        this.$store.dispatch('platform/setGlobalDrawerData', {
          data: {drugId, type: 'storeAdjustmentsByDrug'},
        });
      } else {
        this.writeOffLoading[drugId] = true;
        this.writeOffLoading = {...this.writeOffLoading};
        const {data} = await api.index(`drugs/movesData/${drugId}?storeId=1&drug=false`);
        if (data.success) {
          const storeData = {
            inStore: data.inStore,
            storeId: 1,
            // revisionDate: data.revisionDate,
            drugData: this.filterData(data.drugData),
          };
          this.$store.dispatch('platform/setGlobalDrawerData', {
            data: {...storeData, type: 'storeDrugMoves'},
          });
        }
        this.writeOffLoading[drugId] = false;
      }
    },
    filterData(drugData) {
      return Object.keys(drugData).reduce((acc, timestamp) => {
        acc[timestamp] = {...drugData[timestamp]};
        return acc;
      }, {})
    },
    async adjustStoreAction(drugId, request = false) {
      if (!request) {
        const supplyStoreId = 3;
        const writeOffStoreId = 1;
        const storeRequest = {
          newStore: [...this.adjustStoreData[drugId].newStore],
          newStoreQty: {...this.adjustStoreData[drugId].newStoreQty}
        };
        const updatedStore = {...this.storeData.actualStoreData[drugId]};

        const invoices = {writeOff: [], income: {qty: 0, store_out: null, store_in: supplyStoreId}, transit: []};

        const inStores = Object.values(updatedStore).reduce((acc, q) => acc + +q, 0);

        storeRequest.newStore.forEach((sr) => {
          if (!+sr.newQty || !+sr.storeId) return;
          storeRequest.newStoreQty[sr.storeId] += +sr.newQty;
        });

        let inStoresUpdated = Object.values(storeRequest.newStoreQty).reduce((acc, q) => acc + +q, 0);

        let qtyDiff = inStoresUpdated - inStores;
        // console.log(inStores, inStoresUpdated, qtyDiff);

        if (qtyDiff < 0) {
          Object.keys(storeRequest.newStoreQty).forEach((storeId) => {
            if (qtyDiff === 0) return;
            if (+storeRequest.newStoreQty[storeId] < +updatedStore[storeId]) {
              const diff = +updatedStore[storeId] - +storeRequest.newStoreQty[storeId];
              // console.log(diff);
              const invoiceData = {
                store_in: writeOffStoreId,
                store_out: storeId,
                qty: diff > (qtyDiff * -1) ? (qtyDiff * -1) : diff
              };
              // console.log(invoiceData.qty);
              invoices.writeOff.push(invoiceData);
              qtyDiff += invoiceData.qty;
              updatedStore[storeId] -= invoiceData.qty;
            }
          })
        }
        // console.log(qtyDiff);
        if (qtyDiff > 0) {
          invoices.income.qty += +qtyDiff;
          updatedStore[supplyStoreId] += +qtyDiff;
        }

        Object.keys(storeRequest.newStoreQty).forEach((sId) => {
          if (+sId === +supplyStoreId) return;
          if (+storeRequest.newStoreQty[sId] === +updatedStore[sId]) return;

          if (updatedStore[sId] < +storeRequest.newStoreQty[sId]) {
            let invoiceData = {
              store_in: sId,
              store_out: supplyStoreId,
              qty: +storeRequest.newStoreQty[sId] - updatedStore[sId]
            };
            // console.log()
            invoices.transit.push(invoiceData)
            if (!updatedStore[sId]) updatedStore[sId] = 0;
            updatedStore[sId] += invoiceData.qty;
            updatedStore[supplyStoreId] -= invoiceData.qty;
          }
          if (updatedStore[sId] > +storeRequest.newStoreQty[sId]) {
            const invoiceData = {
              store_out: sId,
              store_in: supplyStoreId,
              qty: updatedStore[sId] - +storeRequest.newStoreQty[sId]
            };
            invoices.transit.push(invoiceData);
            if (!updatedStore[sId]) updatedStore[sId] = 0;
            updatedStore[sId] -= invoiceData.qty;
            updatedStore[supplyStoreId] += invoiceData.qty;
          }
        })

        // console.log(invoices);
        this.adjustStoreModal = {
          header: 'Будут созданы и проведены накладные',
          acceptBtnText: 'Создать накладные',
          drugId,
          invoices: invoices,
        };
        return;
      }
      this.$refs.emptyModal.acceptBtnLoading = true;
      const {data} = await api.post('/invoices/adjustStores', {
        drug_id: drugId,
        invoices: Object.keys(this.adjustStoreModal.invoices).reduce((acc, t) => {
          if (t === 'income') {
            acc.push({...this.adjustStoreModal.invoices[t], type: t});
          } else {
            this.adjustStoreModal.invoices[t].forEach((i) => {
              acc.push({...i, type: t})
            })
          }
          return acc;
        }, [])
      });
      if (data.success) {
        toastr['success']('Сохранено!');
        this.adjustStoreModal = null;
      } else {
        toastr['warning'](data.message || 'Ошибка');
        this.$refs.emptyModal.acceptBtnLoading = false;
      }
    },
    editAdjustStore(drugId) {
      // this.adjustStoreData = {...this.adjustStoreData};
      this.adjustStoreData[drugId] = {
        newStoreQty: {...this.storeData.actualStoreData[drugId]},
        newStore: [{
          storeId: 0,
          newQty: 0,
          allowedStores: Object.keys(this.storeData.actualStoreData[drugId]).reduce((acc, storeId) => {
            if (!this.storeData.actualStoreData[drugId][storeId]) {
              if (!(this.storeData?.requests && this.storeData.requests[drugId] && this.storeData.requests[drugId][storeId])) {
                acc[storeId] = true;
              }
            }
            return acc;
          }, {})
        }]
      };
    },
    getRecordsCount(drugId) {
      let qty = 1
      this.$AllStores.forEach((s) => {
        if ((this.storeData.inStores[drugId] && this.storeData.inStores[drugId][s.id]) || (this.storeData.requests[drugId] && this.storeData.requests[drugId][s.id]) || (this.storeData.transitDetails[drugId] && this.storeData.transitDetails[drugId][s.id])) {
          ++qty
        }
      })
      return qty === 1 ? 2 : qty
    },
    getTransitQty(invoiceData) {
      return +(invoiceData.in || 0) - +(invoiceData.out || 0)
    },
    getExternalLink(drug, storeId = 0) {
      let props = this.$router.resolve({
        name: 'NomenclatureStatistics',
        params: {drug: drug.id},
      })
      return `${props.href}?drugId=${drug.id}&storeId=${storeId}`
    },
  }
}

</script>
